import React, { useEffect, useState } from 'react'
import { PeriodEditingVM } from '../../../Structure/ViewModels/Admin/PeriodEditingVM';
import { CoursesListVM } from '../../../Structure/ViewModels/Admin/CoursesListVM';
import { TermPeriod } from '../../../Structure/Models/Course';

const PeriodEditing = (props:{vm:CoursesListVM,details?:TermPeriod,courseId?:string}) => {
    const [vm , setVm] = useState<{viewModel:PeriodEditingVM}>({viewModel:new PeriodEditingVM(props.details?props.details:{id:'' , course_id:props.courseId?props.courseId:'' , start:'' , end:'' ,hours:''})})
    const control = vm.viewModel
    useEffect(()=>control.subscribeUpdate(setVm),[])

   return (
    <div className={`d-flex flex-wrap justify-content-between py-3 m-2 ${control.Available?' ':'d-none '}`}>
        {
            control.Deleting?(
                <div className='w-100 py-3 d-flex justify-content-center flex-wrap' style={{background:'rgba(240,240,240,1)'}}>
                    <div className='d-flex justify-content-center'>
                        هل تريد حذف الدفعة ؟
                    </div>
                    <div className={`material-symbols-outlined px-3 text-success`} onClick={()=>{ control.delete();}}>
                        check
                    </div>
                    <div className='material-symbols-outlined px-3 text-danger' onClick={()=>control.Deleting = false}>
                        close
                    </div>
                </div>
            ):(
        <div className='d-flex w-100 flex-wrap justify-content-between'>

            <div className='p-2'>
                <input type="date" className='input-field' value={((control.EditMode||control.ButtonsVisibility)?control.EditedDetails:control.Details).start} onChange={a=>control.Start = a.target.value} />
            </div>
            <div className='p-2'>
                <input type="date" className='input-field' value={((control.EditMode||control.ButtonsVisibility)?control.EditedDetails:control.Details).end} onChange={a=>control.End = a.target.value}  />
            </div>
            <div className='p-2 my-auto'>
                <input type="text" className='input-field' style={{width:'70px'}} value={((control.EditMode||control.ButtonsVisibility)?control.EditedDetails:control.Details).hours}  onChange={a=>control.Hours = a.target.value}  />
                <span className='fs-5 my-auto px-3'>ساعة</span>
            </div>
            <div className=' p-2 my-auto d-flex justify-content-end' style={{width:'60px'}}>
                <div className={`material-symbols-outlined px-2 c-pointer text-danger ${control.ButtonsVisibility?' ':'d-none '}`} onClick={()=>{ control.cancel(); }}>close</div>
                {
                    control.Details.id?(
                        <div className={`material-symbols-outlined px-2 c-pointer text-success ${control.ButtonsVisibility?' ':'d-none '}`} onClick={()=>{ control.sendEdit(); }}>save</div>
                    ):(
                        (control.EditedDetails.course_id&&control.EditedDetails.start&&control.EditedDetails.end&&control.EditedDetails.hours)?(
                            <div className={`material-symbols-outlined px-2 c-pointer text-success ${control.ButtonsVisibility?' ':'d-none '}`} onClick={()=>{ control.sendEdit(true,props.vm); }}>add_circle</div>
                        ):(null)
                    )
                }
                <div className={`material-symbols-outlined px-2 c-pointer danger-item ${control.Details.id===''?'d-none ':' '}`} onClick={()=>control.Deleting = true}>delete</div>
            </div>
        </div>)
    }
    </div>
  )
}

export default PeriodEditing
